import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5v10z" />,
  'NorthWest',
);
